export default {
  key: "alert",
  id: "alert_id",
  export: [],
  excel: {
    //max_row: "50000" 
  },
  options: {
    cp_no: {
      key: "cps",
      label: "cp_no",
      value: "cp_no"
    },
    error_id: {
      key: "alert_error_code",
      label: "name_chi",
      value: "error_id"
    },
  },
  sort: {
    field: "alert_id",
    order: "desc"
  },
  sort_fields: [
    "alert_id",
    "cp_id",
    "error_id",
    "location",
    "message",
    "tran_id",
    "cre_dttm",
    "level",
    "last_date",
    "cp_no"
  ],
  filters: {
    alert_id: {},
    cp_id: {},
    error_id: {},
    location: {},
    message: {},
    tran_id: {},
    level: {},
    is_fixes:{
      type: "boolean"
    },
    cp_no: {
      type: "multiselect",
      label: "cp_no",
      value: "cp_no",
      filterable: true
    },
    error_id: {
      type: "multiselect",
      label: "name_chi",
      value: "error_id",
    },
  },
  fields: [
    { key: "alert_id", width: 75 },
    { key: "last_date", type: "datetime", width: 140 },
    { key: "cre_dttm", type: "datetime", width: 140 },
    { key: "cp_no", width: 100 },
    { key: "location", width: 150 },
    // { key: "tran_id", width: 75 },
    // { key: "error_id", width: 100 },
    { key: "error_id", field: "error_id.name_chi", width: 100 },
    { key: "level", width: 75 },
    { key: "message" },
    { key: "is_fixes", type: "boolean", width: 70 },
  ],
  structure: [
  ],
  action: [],
  view: [
  ],
  extra_components: {
  }
}